import React from 'react';

const ProfileScoreReport = ({ scoreAllList, createdAt, userName }) => {

  return (
    <div className="p-10 px-6 space-y-6 bg-white">
      <div className="px-12 space-y-6 page-break">
        <div className="flex items-center justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic">
          <h1 className="text-lg font-semibold">Flow Profile Report</h1>
          <p className="text-lg font-semibold">{userName} | {createdAt}</p>
        </div>

        {/* Header Titles */}
        <div className="mt-6 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Profile Score</h1>
          <p className="text-base text-gray-600 mt-1">A snapshot of all four flow profiles and how strongly each shows up for you.</p>
        </div>

        {/* Profiles Stack Area */}
        <div className="space-y-6 mb-10">
          {scoreAllList.sort((b, a) => (a.score - b.score)).map((profile, idx) => {
            const percentage = (profile.score / profile.maxScore) * 100;
            return (
              <div key={idx} className="space-y-2">
                <div className="flex items-center justify-between text-xl">
                  <div className="flex items-center gap-4">
                    <span className="font-bold text-gray-800">{profile.name}</span>
                    {profile.status && (
                      <span className={`text-base font-bold px-2.5 py-1 w-32 text-center rounded border tracking-wider ${profile.colorClass}`} >
                        {profile.status}
                      </span>
                    )}
                  </div>
                  <div className="font-bold text-gray-800 text-xl">
                    <span className={profile.scoreColor}>{profile.score}{" " + " "}</span>
                    <span className="text-gray-600 font-bold text-base">/{" "}{profile.maxScore}</span>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-sm h-6 overflow-hidden">
                  <div className={`${profile.barColor} h-full transition-all duration-500`} style={{ width: `${percentage}%` }} />
                </div>
                <p className="text-base text-gray-600 leading-relaxed pt-0.5">{profile.text}</p>
              </div>
            );
          })}
        </div>

        {/* <div className="mt-10 border-t border-gray-100 pt-8">
          <h3 className="text-xl font-bold text-gray-900 uppercase tracking-wider mb-4">How to use this report</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {guidelines.map((item, index) => (
              <div key={index} className="border border-gray-100 rounded-xl p-4 bg-gray-100 flex flex-col justify-between">
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-3">{item.title}</h4>
                  <p className="text-base text-gray-700 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div> 
        </div>*/}
      </div>
    </div>
  );
};

export default ProfileScoreReport;